import { c as _c } from "react/compiler-runtime";
import { Empty, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from '@achra/ui/empty';
import { Folder } from 'lucide-react';
interface EmptyStateServiceProps {
  title: string;
  description: string;
}
function EmptyStateService(t0) {
  const $ = _c(8);
  const {
    title,
    description
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <EmptyMedia variant="icon"><Folder /></EmptyMedia>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== title) {
    t2 = <EmptyTitle>{title}</EmptyTitle>;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== description) {
    t3 = <EmptyDescription>{description}</EmptyDescription>;
    $[3] = description;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className="flex h-fit flex-col gap-6"><Empty><EmptyHeader>{t1}{t2}{t3}</EmptyHeader></Empty></div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
export { EmptyStateService };